/* ============
 * Mutations for the users module
 * ============
 *
 * The mutations that are available on the
 * users module.
 */

import { USERS, PROJECTRMDETAILS, BROKERAPPROVALS, CUSTOMERSANDBROKERSLIST, DRMLIST, STOREFORMULADATA, REMOVEFORMULADATA, DEVLIST, OTHERUSER } from './mutation-types';

export default {
  [USERS](state, payload) {
    state.users = payload;
  },
  [PROJECTRMDETAILS](state, payload) {
    state.projectRmDetails = payload;
  },
  [BROKERAPPROVALS](state, payload) {
    state.brokers = payload;
  },
  [CUSTOMERSANDBROKERSLIST](state, payload) {
    state.customersAndBrokersList = payload;
  },
  [DRMLIST](state, payload) {
    state.drms = payload;
  },
  [DEVLIST](state, payload) {
    state.devData = payload;
  },
  [OTHERUSER](state, payload) {
    state.otherUsers = payload;
  },
  [STOREFORMULADATA](state, payload) {
    state.formulaData = payload;
  },
  [REMOVEFORMULADATA](state) {
    state.formulaData = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js